import React, { useState } from 'react';
import {
  combinedEnrollmentTotalsReport,
  customers,
  modals,
  schoolYears as schoolYearsDuck,
  schoolYears
} from "../../ducks";
import { compose } from 'redux';
import {duckify, filterDuck, singleDuck} from "../../utils/duckify";
import withSchoolYear, {defaultEnrollmentYear} from 'hocs/withSchoolYear';

import '../../../../stylesheets/components/reports.scss';
import SchoolYearSelect from "../SchoolYearSelect";
import {withRouter} from "react-router";
import Placeholder from "../Placeholder";
import ExportControls from "../shared/ExportControls";

const CombinedEnrollmentTotalsReport = ( {schoolYearId, schoolYears, customer, onSchoolYearChange, funnelReport, allDucksReady, location, ...props} ) => {
  let report = {};

  // Gets the environment specific domain e.g. .schooladminonline.com/
  const domain = customer.base_url.split(customer.subdomain)[1]

  if (allDucksReady) {
    report = funnelReport[0]
    delete report.id; // We have to have this for redux to be happy but we don't need it
  }
  return (
    <Placeholder.loading ready={allDucksReady && report !== {}}>

    <div className={'reporting'}>
      <h2> Targets & Totals Report for

          <SchoolYearSelect
            schoolYearId={schoolYearId || customer.current_enrollment_year.id}
            schoolYears={schoolYears}
            onSelect={(year) => {
              onSchoolYearChange(year);
            }}
          />


        <ExportControls type={'CombinedEnrollmentTotalsJob'}
                        location={location}
                        url={"/api/reporting/combined_enrollment_total_report/export"}
                        message={<React.Fragment>Your file is being prepared. You can safely close this modal and continue working. The report will automatically download
                          when completed and will also be available on the <a href='/setup/user_jobs' target={'_blank'}>User Jobs page.</a> </React.Fragment>}        />
        <div className={'border-header'}/>
      </h2>

      <div className={'report sub-report five-col with-y-label text-center'}>
        <table className={'table table-striped'}>
          <thead>
          <tr className={'snapshot-header'}>
            <th style={{textAlign: 'left'}}>School</th>
            <th>Total Enrolled</th>
            <th>Target</th>
            <th>Progress to Target (%)</th>
            <th>Spots Open</th>
            <th>Potential Enrollments</th>
          </tr>
          </thead>
          <tbody>
          {funnelReport && Object.keys(report).map((schoolId) => (
            <tr className={schoolId === 'totals' ? 'totals' : ''}>
              <td className={'data'} style={{textAlign: 'left'}}><a target='_blank' href={schoolId !== 'totals' ? "https://" + report[schoolId]['subdomain'] + domain + "reporting/enrollment_snapshot" : null}>{report[schoolId]['name']}</a></td>
              <td className={'data'}>{report[schoolId]['enrolled']}</td>
              <td className={'data'}>{report[schoolId]['target']}</td>
              <td className={'data'}>{report[schoolId]['progress']}%</td>
              <td className={'data'}>{report[schoolId]['diff']}</td>
              <td className={'data'}>{report[schoolId]['potential']}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  </Placeholder.loading>)
}

const mapDucksToProps = ({schoolYearId}) => {
  return {
    customer: singleDuck(customers, 'current'),
    funnelReport: filterDuck(combinedEnrollmentTotalsReport, { school_year_id: schoolYearId }),
    schoolYears: schoolYearsDuck};
};


export default compose(withRouter,
  withSchoolYear(() => ''),
  duckify(mapDucksToProps))(CombinedEnrollmentTotalsReport);
